import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Features from '../components/Features';
import HowItWorks from '../components/HowItWorks';
import Testimonials from '../components/Testimonials';
import Downloads from '../components/Downloads';
import FAQ from '../components/FAQ';
import VenuesBand from '../components/VenuesBand';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="bg-gray-900 min-h-screen">
      <Header />
      <main>
        <Hero />
        <Features />
        <HowItWorks />
        <Testimonials />
        <Downloads />
        <VenuesBand />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
};

export default Home;